import React, { useCallback, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import { OrganisationListItem } from '../../../types/OrganisationInterfaces';
import { OrganisationService } from '../../../services/OrganisationService';
import LoadingComponent from '../../components/shared/LoadingComponent';
import ErrorComponent from '../../components/shared/ErrorComponent';

const OrganisationsPage = (props: any) => {
  const [isLoadingOrganisations, setIsLoadingOrganisations] = useState<boolean>(false);
  const [isOrganisationsLoaded, setIsOrganisationsLoaded] = useState<boolean>(false);
  const [organisations, setOrganisations] = useState<OrganisationListItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  const history = useHistory();
  const goTo = (location: string) => {
    history.push(location);
  };

  /*
  const loadOrganisations = useCallback(async (): Promise<void> => {
    setIsLoadingOrganisations(true);
    setIsOrganisationsLoaded(false);
    try {
      const response: OrganisationListItem[] = await OrganisationService.getOrganisations();
      setOrganisations(response);
      setIsOrganisationsLoaded(true);
    } catch (error) {
      setError(error.message);
    }
    setIsLoadingOrganisations(false);
  }, [setIsLoadingOrganisations, setIsOrganisationsLoaded, setError, setOrganisations]);

  useEffect(() => {
    if (!error && !isOrganisationsLoaded && !isLoadingOrganisations) {
      loadOrganisations();
    }
  }, [isLoadingOrganisations, isOrganisationsLoaded, error, loadOrganisations]);
   */

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 90, editable: false },
    {
      field: 'name',
      headerName: 'Organisation name',
      flex: 60,
      editable: false
    },
    {
      field: 'roles',
      headerName: 'Roles',
      flex: 40,
      editable: false
    },
    {
      field: '', // Don't repeat ID - does weird things with the ordering of the columns
      headerName: 'Edit',
      width: 100,
      renderCell: (params: GridRenderCellParams<number>) => (
        <Button onClick={() => goTo(`/app/organisations/${params.row.id}`)} type={'button'} variant={'text'}>
          View
        </Button>
      )
    }
  ];

  return (
    <Grid container>
      <Grid item lg={12}>
        <Grid container sx={{ mb: 4 }}>
          <Grid item lg={6}>
            <Typography variant={'h4'}>Organisations</Typography>
          </Grid>
          <Grid item lg={6} style={{ textAlign: 'right' }}>
            <Button variant={'contained'} onClick={() => goTo('/app/add-organisation')}>
              Create
            </Button>
          </Grid>
        </Grid>
        <Paper>
          <Box sx={{ p: 4, mt: 3 }}>
            {isLoadingOrganisations && <LoadingComponent />}
            {error && <ErrorComponent message={error} />}
            {isOrganisationsLoaded && (
              <DataGrid
                rows={organisations}
                columns={columns}
                autoHeight={true}
                pageSize={10}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
              />
            )}
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default OrganisationsPage;
